<template>
    <div class = "vhead_flex">
        <div class = "header_top">
            <div class = "headerTop_container clear">
                <div class = "headerTop_left f1">
                    <span class = "title">欢迎来到济邦邦！</span>
                    <router-link v-if="showId==1" to="/login" tag="span" @click.native="goLogin()">登录</router-link>
                    <router-link v-else to="/home" tag="span">{{phone}}</router-link>
                    <i>|</i>
                    <router-link v-if="showId==1" to="/register" tag="span">免费注册</router-link>
                    <span v-else @click="goOut()">退出</span>
                </div>
                <ul class = "headerTop_right f1">
                    <router-link tag="li" to="/index">首页</router-link>
                    <li>|</li>
                    <li @click="goUser()">我的账号</li>
                    <li>|</li>
                    <li @click="goCar()">购物车</li>
                    <li>|</li>
                    <li class = "code_fuji">
                        <span>关注公众号</span>
                        <p class="guanzhu_code">
                            <img src="../../assets/image/qrcode.jpg" alt="">
                            <span>微信扫码关注公众号</span>
                        </p>
                    </li>
                    <li>|</li>
                    <li @click="goService()">在线客服</li>
                </ul>
            </div>
        </div>
        <div class="header_content">
            <div class = "headerCont_left">
                <a href="/" style="width:200px;height:71px;display:inline-block;">
                    <img style="width:100%;height:100%;" src="../../assets/image/logo_i.png" alt="">
                </a>
            </div>
            <div class = "headerCont_center">
                <ul class = "headerCont_ul">
                    <li class = "headerCont_li">
                        <a class = "li_hover" target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            0元注册公司
                            <img class = "header_hot" src="../../assets/image/hot.gif" alt="">
                            <b class = "header_caret"></b>
                        </a>
                        <div class = "header_erCont header_erCont1">
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                独资公司
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                合伙公司
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                股份公司
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                进出口公司
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                人力资源公司
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                个体工商户
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                微商执照
                            </a>
                        </div>
                    </li>
                    <li class = "headerCont_li">
                        <a target="_blank" class = "li_hover" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            代理记账
                            <img class = "header_hot" src="../../assets/image/hot.gif" alt="">
                            <b class = "header_caret"></b>
                        </a>
                        <div class = "header_erCont">
                                <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                    记账报税
                                    <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                                </a>
                                <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                    税务筹划
                                    <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                                </a>
                                <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                    税务年报
                                    <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                                </a>
                                <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                    国地税报销
                                </a>
                                <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                    税务清缴
                                </a>
                        </div>
                    </li>
                    <li class = "headerCont_li">
                        <a target="_blank" class = "li_hover" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            工商变更
                            <img class = "header_hot" src="../../assets/image/hot.gif" alt="">
                            <b class = "header_caret"></b>
                        </a>
                        <div class = "header_erCont">
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                法人变更
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                地址变更
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                股东变更
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                经验范围变更
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                注册资金变更
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                股权变更
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                监事变更
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                名称变更
                            </a>
                            <a target="_blank" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                                增资扩股
                            </a>
                        </div>
                    </li>
                    <li class = "headerCont_li">
                        <a target="_blank" class = "li_hover" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            商标注册
                        </a>
                    </li>
                    <li class = "headerCont_li">
                        <a target="_blank" class = "li_hover" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            网站建设
                        </a>
                    </li>
                    <li class = "headerCont_li">
                        <a target="_blank" class = "li_hover" href="https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=bd437048e81142888638c1d67930294e&sid=bd437048e81142888638c1d67930294e">
                            节税
                            <img class = "header_hot" src="../../assets/image/hot.gif" alt="">
                        </a>
                    </li>
                    <li class = "headerCont_li">
                        <a class = "li_hover" href="javascript:;">
                            更多
                            <b class = "header_caret"></b>
                        </a>
                        <div class = "header_erCont">
                            <a target="_blank" href="http://hm.hzjbqy.com/hm.html">
                                智能核名
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="http://hm.hzjbqy.com/businessScope.html">
                                经营范围              
                            </a>
                            <a target="_blank" href="http://hm.hzjbqy.com/qm.html">
                                智能取名
                            </a>
                            <a target="_blank" href="https://hzjbqy.cn/cityPart" class = "reload_city">
                                城市合伙人
                                <img class = "header_erHot" src="../../assets/image/hot.gif" alt="">
                            </a>
                            <a target="_blank" href="http://hm.hzjbqy.com/logo/index.html" class = "reload_city">
                                智能LOGO
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
            <div class = "headerCont_right">
                <div class = "right_item">
                    <span style = "display:block;">
                        <img src="../../assets/image/tgPhone.png" alt="">
                    </span>
                    <a href="javascript:;" style="color:#484848; font-size: 25px;font-weight:600;" class = "phone_hover">{{phoneData}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            getToken:'',
            showId:1,
            name:'',
            phone:'',
            phoneData:'',
        }
    },
    mounted() {
        this.getToken=window.localStorage.getItem('token')
        this.phone=window.localStorage.getItem('phone')
        this.name=window.localStorage.getItem('name')
        this.getPhoneVal()
        if(this.getToken==null || this.getToken==''){
            this.showId=1
        }else{
            this.showId=2
        }
    },
    methods: {
        goLogin(){
            window.localStorage.setItem('path','/home')
        },
        goCar(){
            if(this.getToken==null){
                this.$router.push({path:'/login'})
                window.localStorage.setItem('path','/companyCar')
            }else{
                this.$router.push({path:'/companyCar'})
            }
        },
        goUser(){
            if(this.getToken==null){
                this.$router.push({path:'/login'})
                window.localStorage.setItem('path','/home')
            }else{
                this.$router.push({path:'/home'})
            }
        },
        // 去客服
        goService(){
            window.open('https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=5d03cb84434f42888ac1e80648748afe&sid=5d03cb84434f42888ac1e80648748afe')
        },
        // 得到电话
        getPhoneVal(){
            this.$axios({
                method:'get',
                url:'/jbbcs/owManage/cusWebConfig/getUnifiedPhone',
            }).then((res) =>{
                if(res.data.code==1){
                    this.phoneData=res.data.content
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{
                this.$message.error('操作失败，请重试');
            })
        },
        // 退出
        goOut(){
            window.localStorage.clear()
            window.location.reload()
            this.showId=1
        },
    },
}
</script>
<style lang="scss" scoped>
    .vhead_flex{
        width:100%;
        height:126px;
    }
    // 头部
    .header_top{
        width:100%;
        height:35px;
        line-height: 35px;
        background:#efefef;
    }
    .headerTop_container{
        width:1200px;
        margin:0 auto;
        text-align: left;

    }
    .headerTop_left,.headerTop_right{
        width:50%;
        color:#999;
        cursor: pointer;
        >span:hover{
            color:#fda45e;
        }   
    }
    .headerTop_left{
        >.title{
            display: inline-block;
            margin-right:20px;
        }
    }
    .headerTop_right{
        text-align: right;
        >li{
            display: inline-block;
            margin:0 5px;
            cursor: pointer;
        }
        >li:hover{
            color:#fda45e;
        }
    }
    .header_content{
        width:1175px;
        height:71px;
        margin:10px auto;
    }
    .headerCont_left{
        margin-right: 20px;
        margin-left: 30px;
        float:left!important;
    }
    .headerCont_center{
        float:left!important;
    }
    .headerCont_ul{
        float:left;
    }
    .headerCont_li{
        float:left;
        display:block;
        position: relative;
    }
    .headerCont_li>a{
        padding: 0;
        margin-left: 15px;
        margin-right: 15px;
        height: 64px;
        line-height: 64px;
        border-bottom: 3px solid transparent;
        font-size: 18px;
        text-align: center;
    }
    .header_hot{
        position: absolute;
        top: 6px;
        right: 0px;
    }
    .header_caret{
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 2px;
        vertical-align: middle;
        border-top: 4px dashed;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        font-weight: 700;
        color:#999;
        -webkit-transition: all .3s linear 0s;
        transition: all .3s linear 0s;    
    }
    .header_erCont{
        position: absolute;
        float: left;
        margin: 2px 0 0;
        font-size: 14px;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        display: block;
        visibility: hidden;
        opacity: 0;
        top: 0;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        border: none;
        transform: scale(0);
        border-radius: 3px;
        z-index: 1007;
        left: 50%;
        margin-left: -70px;
        width: 140px;
        transition: all .3s linear 0s;
    }
    .header_erCont>a{
        display: block;
        margin-left: 0;
        margin-right: 0;
        padding-left: 35px;
        height: 36px;
        line-height: 36px;
        text-align: left;
        font-size: 14px;
        border-bottom: none;
        color: #666;
        text-decoration: none;
    }
    .headerCont_li:hover .header_caret{
        border-top-color: #FF513F;
        transition-timing-function: ease;
        -webkit-transition-timing-function: ease;
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        -webkit-transition: all .3s linear 0s;
        transition: all .3s linear 0s;      
    }
    a:hover{
        color:#FF513F;
    }
    .headerCont_li:hover .li_hover{
        color:#FF513F;
    }
    .headerCont_li:hover .header_erCont{
        top: 100%;
        visibility: visible;
        opacity: 1;
        transform: scale(1);
        transition: all .3s linear 0s;
    }
    .headerCont_right{
        float:right!important;
        margin-right:30px;
        margin-top:-2px;
    }
    .right_item{
        float:right;
    }
    .phone_hover:hover{
        text-decoration: underline;
    }
    .f1{
        float: left;
    }
    .clear:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
    }
    .code_fuji{
        position: relative;
    }
    .guanzhu_code{
        position: absolute;
        top:33px;
        left:0;
        border:1px solid #ccc;
        height:150px;
        padding-top:5px;
        background:#fff;
        font-size:12px;
        text-align: center;
        color:#fda45e;
        display: none;
        >span{
            display:block;
            margin-top:-10px;
        }
    }
    .code_fuji:hover .guanzhu_code{
        display:block;
    }
</style>




// WEBPACK FOOTER //
// src/components/common/vhead.vue